'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var PropTypes = require('prop-types');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DiscoverIcon = function DiscoverIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Discover' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 1536 1024",
    title: title,
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M238.163 432.667c0 21.333-8.474 42-23.467 56-13.037 12-30.637 17.333-58.015 17.333h-11.081v-146.667h11.081c27.378 0 44.326 4.667 58.015 18 14.993 13.333 23.467 34 23.467 55.333zM1395.852 389.333c0 22.667-14.341 34.667-41.718 34.667h-12.385v-67.333h13.037c26.726 0 41.067 11.333 41.067 32.667zM281.837 432.667c0-65.333-47.585-111.333-116.681-111.333h-61.926v222h61.926c32.593 0 56.711-7.333 77.57-25.333 24.77-21.333 39.111-52.667 39.111-85.333zM301.393 543.333h42.37v-222h-42.37v222zM509.985 476c0-35.333-14.341-51.333-62.578-69.333-25.422-9.333-32.593-16-32.593-28 0-14 13.037-24.667 31.289-24.667 13.037 0 23.467 5.333 34.548 18l22.163-29.333c-18.252-16.667-40.415-24.667-63.881-24.667-38.459 0-67.793 27.333-67.793 63.333 0 30.667 13.689 46.667 53.452 61.333 16.296 6 24.77 9.333 29.333 12.667 8.474 5.333 12.385 13.333 12.385 22.667 0 18-13.689 31.333-32.593 31.333-20.207 0-36.504-10-46.281-29.333l-27.378 26.667c19.556 29.333 43.022 42.667 74.963 42.667 44.326 0 74.963-30 74.963-73.333zM691.2 536v-51.333c-16.948 17.333-31.941 24.667-50.844 24.667-43.022 0-73.007-32-73.007-76.667 0-42.667 31.289-76.667 71.052-76.667 20.207 0 35.2 7.333 52.8 25.333v-51.333c-18.252-9.333-33.896-13.333-52.148-13.333-63.881 0-115.378 51.333-115.378 116 0 65.333 50.193 116 114.726 116 18.252 0 33.896-3.333 52.8-12.667zM1494.281 938.667v-351.333c-104.296 66.667-471.289 280-1064.474 394h1022.756c22.815 0 41.719-19.333 41.719-42.667zM939.556 434c0-66.667-52.8-120.667-117.985-120.667s-117.985 54-117.985 120.667c0 66.667 52.8 120.667 117.985 120.667s117.985-54 117.985-120.667zM1038.637 549.333l93.867-228h-46.281l-58.667 149.333-58.015-149.333h-46.282l92.563 228h22.815zM1151.407 543.333h119.941v-37.333h-77.57v-60h74.963v-37.333h-74.963v-49.333h77.57v-38h-119.941v222zM1406.281 543.333h52.148l-68.444-93.333c31.941-6.667 49.541-28.667 49.541-62.667 0-42-28.030-66-76.919-66h-63.23v222h42.37v-88.667h5.867l58.667 88.667zM1536 89.333v845.333c0 49.333-38.459 89.333-86.044 89.333h-1329.778c-47.585 0-86.044-40-86.044-89.333v-845.333c0-49.333 38.459-89.333 86.044-89.333h1329.778c47.585 0 86.044 40 86.044 89.333z"
    })]
  }));
};
DiscoverIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DiscoverIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Discover'",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var DiscoverIcon$1 = DiscoverIcon;
DiscoverIcon.propTypes = {
  title: PropTypes__default.default.string
};

exports.default = DiscoverIcon$1;
//# sourceMappingURL=DiscoverIcon.js.map
